import { render } from "./CliniqueComponent.vue?vue&type=template&id=98b560ca"
import script from "./CliniqueComponent.vue?vue&type=script&lang=js"
export * from "./CliniqueComponent.vue?vue&type=script&lang=js"

import "./CliniqueComponent.vue?vue&type=style&index=0&id=98b560ca&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__